exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".count-badge[data-v-66e78921]{position:absolute;right:7px;top:0;z-index:100;font-size:68%}.beta[data-v-66e78921]{float:right;z-index:1000;margin-top:-2rem;height:.75rem}.nav-link[data-v-66e78921]{position:relative}.nav-link[data-v-66e78921]:hover{color:#ffc93a!important}.nav-link span[data-v-66e78921]{position:relative;display:block;margin:0 auto;padding-left:55px;font-size:15px}.icon[data-v-66e78921]{position:absolute;left:13px;top:0;bottom:0;width:auto;height:22px;margin:auto;margin-right:.5rem;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-66e78921","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Sidebar.vue
// module id = 7ui3
// module chunks = 1